{
  "version": 1,
  "asset_id": "e2829bc5-c093-4ec1-8acb-410ec49f59ac",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/e2829bc5-c093-4ec1-8acb-410ec49f59ac/monroya-connect.zip",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/e2829bc5-c093-4ec1-8acb-410ec49f59ac/monroya-connect.zip",
  "original_filename": "monroya-connect.zip",
  "size": 13906,
  "content_type": "application/zip",
  "created_at": "2026-10-26T15:53:28Z"
}
